<template>
  <div class="about">
    <div id="nav">
      <router-link to="/">home</router-link> |
      <router-link to="/about">about</router-link>
    </div>
    <h1 class="title strong">About this game</h1>
    <div class="abouttext">
      <p>
        This game is made for you by
        <a href="https://www.studiokromhout.nl" title="Studio Kromhout"
          >Studio Kromhout</a
        >.
      </p>
      <br />
      <p>
        Country flag icons provided by the Flag Icons repository
        (https://github.com/lipis/flag-icons), licensed under the MIT License.
      </p>
    </div>
  </div>
</template>
<style>
.abouttext {
  margin: calc(4 * var(--default-margin));
}
.abouttext a {
  color: var(--green);
}
</style>
